import { getIsSeller } from '@app/ducks';
import { compiledPaths } from '@app/paths';
import { useNavigationItems } from '@app/services/hooks/pages/useNavigationItems';
import { useSelectionNavigationItems } from '@app/utils/hooks/navigation/useSelectionNavigationItems';
import React from 'react';
import { useSelector } from 'react-redux';

import { Header } from './Header';
import { HeaderWrapper } from './HeaderWrapper';

export const AppHeader = () => {
  const { data: navigationItemsData } = useNavigationItems({ refetchOnMount: false });
  const navigationItems = React.useMemo(() => navigationItemsData?.items ?? [], [navigationItemsData]);
  const selectionNavigationItems = useSelectionNavigationItems(navigationItems);
  const isSeller = useSelector(getIsSeller);

  const logoUrl = isSeller ? compiledPaths.ROOT({}) : compiledPaths.HOME_ROOT({});

  return (
    <HeaderWrapper>
      <Header logoUrl={logoUrl} navigationItems={selectionNavigationItems} />
    </HeaderWrapper>
  );
};
